import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import handleOpenWhatsApp from 'services/whatsappService';
import {
  NASIOL,
  adsFinal,
  WHATSAPP_ADS_DEFAULT,
  WHATSAPP_PHONE,
} from '../nasiolContent';

const AdsFinalCta = ({ onSwitchWeb }) => (
  <Box
    component="section"
    py={{ xs: 5.5, md: 7 }}
    px={{ xs: 2.5, sm: 4, md: 7 }}
    bgcolor={NASIOL.sand}
  >
    <Box maxWidth={640} mx="auto">
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Space Grotesk", "Outfit", sans-serif',
          fontWeight: 700,
          fontSize: { xs: '1.7rem', md: '2.2rem' },
          color: NASIOL.ink,
          mb: 1,
        }}
      >
        {adsFinal.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: '"Source Sans 3", sans-serif',
          color: NASIOL.inkMuted,
          fontSize: '1.05rem',
          lineHeight: 1.5,
          mb: 3,
          maxWidth: 420,
        }}
      >
        {adsFinal.subtitle}
      </Typography>

      <Box display="flex" flexWrap="wrap" sx={{ gap: 1.25 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<WhatsAppIcon />}
          onClick={() =>
            handleOpenWhatsApp(null, WHATSAPP_ADS_DEFAULT, WHATSAPP_PHONE)
          }
          sx={{
            px: 3,
            py: 1.35,
            borderRadius: 1.5,
            fontWeight: 800,
            fontFamily: '"Outfit", sans-serif',
            bgcolor: NASIOL.ocean,
            color: NASIOL.white,
            '&:hover': { bgcolor: NASIOL.oceanDeep },
          }}
        >
          {adsFinal.cta}
        </Button>
        {onSwitchWeb ? (
          <Button
            type="button"
            variant="outlined"
            size="large"
            onClick={onSwitchWeb}
            sx={{
              px: 2.75,
              py: 1.35,
              borderRadius: 1.5,
              fontWeight: 800,
              fontFamily: '"Outfit", sans-serif',
              borderColor: NASIOL.lagoon,
              color: NASIOL.ocean,
              '&:hover': { borderColor: NASIOL.ocean, bgcolor: NASIOL.white },
            }}
          >
            {adsFinal.webCta}
          </Button>
        ) : null}
      </Box>

      <Typography
        sx={{
          mt: 4,
          fontFamily: '"Source Sans 3", sans-serif',
          fontSize: '0.8rem',
          color: NASIOL.inkMuted,
        }}
      >
        {adsFinal.copyright}
      </Typography>
    </Box>
  </Box>
);

AdsFinalCta.propTypes = {
  onSwitchWeb: PropTypes.func,
};

export default AdsFinalCta;
